import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { Image } from '@textbook-api-client/lib/actions/util-types/image.model';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../../../external/providers/textbook-actions-handler';
import { first } from 'rxjs';
import { ScaledImageHelperService } from "../../services/scaled-image-helper.service";
import { MAX_PERCENT } from "../../../../models/const/utility";

@Component({
  selector: 'txtb-zoom-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  providers: [ScaledImageHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ImageZoomComponent implements OnChanges {
  @ViewChild('wrapper') wrapper!: ElementRef<HTMLDivElement>;
  @Input() alt = '';
  @HostBinding('class.scroll-disabled')
  @Input() scrollDisabled = false;
  @Input() imagesScalingEnabled = false;
  @Input() percentageScale: number | null = null;

  @Input() set imageData(imageData: Image | null) {
    this.imageMetaData = imageData;
  }

  @Output() loaded = new EventEmitter<undefined>();

  imageMetaData: Image|null = null;
  imageSrc: string[] = [];
  readonly scaleImageToWidth$ = this.scaledImageHelperService.scaleImageToWidth$;
  readonly scaleImageToHeight$ = this.scaledImageHelperService.scaleImageToHeight$;
  readonly MAX_PERCENT = MAX_PERCENT;

  constructor(
    @Inject(TextbookActionsHandlerToken) public textbookActionsHandler: TextbookActionsHandler,
    private readonly cdr: ChangeDetectorRef,
    private readonly scaledImageHelperService: ScaledImageHelperService,
    private readonly elRef: ElementRef<HTMLElement>,
  ) {
    this.scaledImageHelperService.init(elRef);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes?.imageData?.currentValue?.resourceId) {
      this.textbookActionsHandler
        .getResourceBlobAsString(String(changes.imageData.currentValue.resourceId))
        .pipe(first())
        .subscribe((data) => {
          this.imageSrc[0] = data;
          this.cdr.markForCheck();
        });
    }
  }

  adjustImageSize(wrapper: HTMLElement, image: HTMLImageElement): void {
    if (!this.imageMetaData) {
      return;
    }
    if (wrapper) {
      wrapper.scrollTo(0, 0);
    }
    this.scaledImageHelperService.setImage(image);
    this.loaded.emit();
  }
}
